import { Component, OnInit, OnDestroy, AfterViewInit, HostListener, ViewEncapsulation } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { DriverService } from '@app/services/driver.service';
import { NotificationService } from '@app/services/notification.service';
import { ToastService } from '@app/services/toast.service';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BreadcrumbService } from '@app/services/breadcrumb.service';
interface Driver {
  id: number;
  firstName: string;
  lastName: string;
  initials: string;
  isHeadDriver: boolean;
  isOnline: boolean;
  assignedOrders: number;
  completedDeliveries: number;
  lastDeliveryTime: string;
  timeBackWarehouse: string;
  status: 'active' | 'inactive';
  avatarClass: string;
}

interface FilterChip {
  label: string;
  count: number;
  type: 'status' | 'type';
  value: string;
  active: boolean;
}
@Component({
  selector: 'app-driver-listing',
  templateUrl: './driver-listing.component.html',
  styleUrl: './driver-listing.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class DriverListingComponent implements OnInit, OnDestroy, AfterViewInit {
  // Search
  searchQuery: string = '';
  cross: boolean = false;
  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;
  isLoading: boolean = true;
  activeContactId: string | number | null = null;
  showCopiedId: string | number | null = null;

  // Filter chips
  filterChips: FilterChip[] = [
    { label: 'All Drivers', count: 0, type: 'status', value: 'all', active: true },
    { label: 'Active', count: 0, type: 'status', value: 'active', active: false },
    { label: 'Inactive', count: 0, type: 'status', value: 'inactive', active: false },
    { label: 'Head Drivers', count: 0, type: 'type', value: 'head', active: false },
    { label: 'Associated Drivers', count: 0, type: 'type', value: 'associated', active: false }
  ];

  // All drivers data
  allDrivers: Driver[] = [
    {
      id: 1,
      firstName: 'Anush',
      lastName: 'M',
      initials: 'AM',
      isHeadDriver: true,
      isOnline: false,
      assignedOrders: 778,
      completedDeliveries: 759,
      lastDeliveryTime: '08:59 PM',
      timeBackWarehouse: '09:11 PM',
      status: 'active',
      avatarClass: 'avatar-grey'
    },
    {
      id: 2,
      firstName: 'Martin',
      lastName: 'R',
      initials: 'MR',
      isHeadDriver: false,
      isOnline: true,
      assignedOrders: 46,
      completedDeliveries: 42,
      lastDeliveryTime: '07:51 AM',
      timeBackWarehouse: '07:51 AM',
      status: 'active',
      avatarClass: 'avatar-grey'
    },
    {
      id: 3,
      firstName: 'Paul',
      lastName: 'R',
      initials: 'PR',
      isHeadDriver: true,
      isOnline: true,
      assignedOrders: 550,
      completedDeliveries: 538,
      lastDeliveryTime: '09:21 PM',
      timeBackWarehouse: '09:50 PM',
      status: 'active',
      avatarClass: 'avatar-grey'
    },
    {
      id: 4,
      firstName: 'Tony',
      lastName: 'R',
      initials: 'TR',
      isHeadDriver: true,
      isOnline: false,
      assignedOrders: 743,
      completedDeliveries: 731,
      lastDeliveryTime: '07:04 PM',
      timeBackWarehouse: '08:13 PM',
      status: 'active',
      avatarClass: 'avatar-grey'
    },
    {
      id: 5,
      firstName: 'Avinash',
      lastName: 'Singh',
      initials: 'AS',
      isHeadDriver: true,
      isOnline: false,
      assignedOrders: 0,
      completedDeliveries: 0,
      lastDeliveryTime: '03:26 PM',
      timeBackWarehouse: '03:27 PM',
      status: 'active',
      avatarClass: 'avatar-grey'
    },
    {
      id: 6,
      firstName: 'Harold',
      lastName: 'H',
      initials: 'HH',
      isHeadDriver: false,
      isOnline: false,
      assignedOrders: 50,
      completedDeliveries: 50,
      lastDeliveryTime: '09:15 PM',
      timeBackWarehouse: '09:35 PM',
      status: 'active',
      avatarClass: 'avatar-grey'
    },
    {
      id: 7,
      firstName: 'Jermaine',
      lastName: 'R',
      initials: 'JR',
      isHeadDriver: false,
      isOnline: false,
      assignedOrders: 116,
      completedDeliveries: 110,
      lastDeliveryTime: '01:22 AM',
      timeBackWarehouse: '01:57 AM',
      status: 'active',
      avatarClass: 'avatar-7'
    }
  ];

  // Filtered drivers (what's displayed)
  filteredDrivers: any[] = [];
  allDriversCached: any[] = [];

  // Pagination
  currentPage: number = 1;
  totalPages: number = 0;
  itemsPerPage: number = 10;
  tabName: string = 'all';

  constructor(private route: ActivatedRoute,
    private router: Router,
    public authService: AuthServiceService,
    public driverService: DriverService,
    private toastr: ToastrService,
    private toast: ToastService, private dialogService: DialogService, public notificationService: NotificationService, private shareddta: ShareddtaService, private breadcrumbService: BreadcrumbService) { }

  ngAfterViewInit(): void {
    // Moved signalPageReady to driverList to ensure spinner stays up until data loads
  }

  ngOnInit(): void {
    this.breadcrumbService.set([
      { label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', action: () => this.router.navigate(['/admin/dashboard']) },
      { label: 'Drivers' }
    ]);
    const svc = this.driverService;
    
    // Check if we have cached data and NO refresh is forced
    if (svc.cachedDriverList.length > 0 && !svc.forceRefreshListing) {
      this.allDriversCached = svc.cachedDriverList;
      // Force all cached drivers to use the new grey theme
      this.allDriversCached.forEach(d => d['avatarClass'] = 'avatar-grey');
      this.tabName = svc.cachedTabName;
      this.searchQuery = svc.cachedSearchQuery;
      this.currentPage = svc.cachedCurrentPage;
      this.cross = !!this.searchQuery;

      // Update active state in filter chips
      this.filterChips.forEach(chip => {
        chip.active = chip.value === this.tabName;
      });

      this.applyFilters();
      this.getDriverCount();
      this.isLoading = false;
    } else {
      // Fetch fresh data if cache is empty or refresh is forced
      this.fetchAllDrivers();
      svc.forceRefreshListing = false; // Reset flag after fetch
    }

    // Set up debounced search
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(1000), // Match global header debounce
      distinctUntilChanged()
    ).subscribe(query => {
      this.searchQuery = query;
      this.currentPage = 1; // Reset to first page on new search
      this.applyFilters();
    });
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    // Save current state to service for next time
    const svc = this.driverService;
    svc.cachedDriverList = this.allDriversCached;
    svc.cachedTabName = this.tabName;
    svc.cachedSearchQuery = this.searchQuery;
    svc.cachedCurrentPage = this.currentPage;
  }
  driverCount: any;
  fetchAllDrivers() {
    this.isLoading = true;
    this.driverService.ndriverList(undefined, 'all', '', '').subscribe({
      next: (data: any) => {
        if (data?.result?.results) {
          this.allDriversCached = data.result.results;
          this.allDriversCached.forEach((element: any) => {
            element['avatarClass'] = 'avatar-grey';
          });
          this.applyFilters();
          this.getDriverCount(); // Recalculate counts from local data
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Failed to fetch drivers', err);
      }
    });
  }

  applyFilters() {
    let results = [...this.allDriversCached];

    // Status Filter
    if (this.tabName === 'active') {
      results = results.filter(d => d.is_active);
    } else if (this.tabName === 'inactive') {
      results = results.filter(d => !d.is_active);
    }

    // Group Filter
    if (this.tabName === 'head') {
      results = results.filter(d => d.groups?.some((g: any) => g.id === 3));
    } else if (this.tabName === 'associated') {
      results = results.filter(d => !d.groups?.some((g: any) => g.id === 3));
    }

    // Search Filter
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      results = results.filter(d =>
        d.first_name?.toLowerCase().includes(query) ||
        d.last_name?.toLowerCase().includes(query) ||
        d.email?.toLowerCase().includes(query) ||
        d.phone?.includes(query)
      );
    }

    this.driverCount = results.length;
    this.totalPages = Math.ceil(this.driverCount / this.itemsPerPage);

    // Ensure currentPage is valid after filtering
    if (this.currentPage > this.totalPages && this.totalPages > 0) {
      this.currentPage = 1;
    }

    // Pagination
    const start = (this.currentPage - 1) * this.itemsPerPage;
    this.filteredDrivers = results.slice(start, start + this.itemsPerPage);
  }

  driverList() {
    this.applyFilters();
  }
  headerCountsData: any;
  getDriverCount() {
    if (!this.allDriversCached.length) return;

    let headCount = 0;
    let associatedCount = 0;
    let activeCount = 0;
    let inactiveCount = 0;

    this.allDriversCached.forEach(d => {
      if (d.is_active) activeCount++;
      else if (d.is_active === false) inactiveCount++;

      if (d.groups?.some((g: any) => g.id === 3)) headCount++;
      else associatedCount++;
    });

    this.filterChips = this.filterChips.map(chip => {
      let count = 0;
      switch (chip.value) {
        case 'all': count = this.allDriversCached.length; break;
        case 'active': count = activeCount; break;
        case 'inactive': count = inactiveCount; break;
        case 'head': count = headCount; break;
        case 'associated': count = associatedCount; break;
      }
      return { ...chip, count };
    });
  }

  getDriverInitials(driver: any): string {
    if (!driver) return '';

    const firstInitial = driver.first_name
      ? driver.first_name.trim().charAt(0).toUpperCase()
      : '';

    const lastInitial = driver.last_name
      ? driver.last_name.trim().charAt(0).toUpperCase()
      : '';

    return [firstInitial, lastInitial].filter(Boolean).join(' ');
  }
  userTimeZone: any;
  getUserTimeZone() {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  formatETDA(etda?: string): string {
    if (!etda || typeof etda !== 'string') {
      return '--';
    }
    const parsedDate = new Date(etda);

    if (isNaN(parsedDate.getTime())) {
      return etda;
    }

    return parsedDate.toLocaleString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: this.userTimeZone
    });
  }

  // Search drivers

  onSearch(): void {
    const query = this.searchQuery.toLowerCase().trim();
    this.cross = !!this.searchQuery;
    this.searchSubject.next(query);
  }
  //   this.filteredDrivers = [...this.allDrivers];
  //   return;
  // }

  // this.filteredDrivers = this.allDrivers.filter(driver => {
  //   const fullName = `${driver.firstName} ${driver.lastName}`.toLowerCase();
  //   return fullName.includes(query);
  // });
  // Filter by chip

  onFilterClick(clickedChip: FilterChip): void {
    // Clear search
    this.searchQuery = '';
    this.currentPage = 1;
    localStorage.setItem('DriverPage', '1');

    // Update active state
    this.filterChips.forEach(chip => {
      chip.active = chip === clickedChip;
    });
    this.tabName = clickedChip.value;

    this.driverList();

  }

  // Send push notification to all
  sendPushNotificationToAll(): void {
    console.log('Sending push notification to all drivers...');
    alert('Sending push notification to all drivers...');
    // TODO: Implement API call
  }

  // Add driver
  addDriver(): void {
    this.driverService.forceRefreshListing = true;
    this.router.navigate(['/admin/driver/add']);
  }

  // Call driver
  callDriver(driver: any, event: Event): void {
    event.stopPropagation();
    const phone = this.getDriverPhone(driver);
    if (!phone) {
      this.toast.show('error', 'No phone number available');
      return;
    }

    // Toggle popover
    if (this.activeContactId === driver.id) {
      this.activeContactId = null;
    } else {
      this.activeContactId = driver.id;
    }
  }

  copyToClipboard(phone: string, event: Event, driverId: string | number): void {
    event.stopPropagation();
    navigator.clipboard.writeText(phone).then(() => {
      this.showCopiedId = driverId;
      setTimeout(() => {
        this.showCopiedId = null;
      }, 2000);
    });
  }

  openWhatsApp(phone: string, event: Event): void {
    event.stopPropagation();
    const cleanPhone = phone.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanPhone}`, '_blank');
  }

  initiateCall(phone: string, event: Event): void {
    event.stopPropagation();
    window.location.href = `tel:${phone}`;
  }

  getDriverPhone(driver: any): string {
    const countryCode = driver?.country_code || driver?.dial_code || '';
    const phone = (
      driver?.phone_number ||
      driver?.phone ||
      driver?.mobile ||
      driver?.mobile_no ||
      ''
    ).toString().trim();

    if (countryCode && phone) {
      // Ensure country code has + prefix if it's just numbers
      const formattedCode = countryCode.toString().startsWith('+') ? countryCode : `+${countryCode}`;
      return `${formattedCode} ${phone}`;
    }
    return phone;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.contact-trigger-wrapper')) {
      this.activeContactId = null;
    }
  }

  // Send notification to driver
  notifyDriver(driver: Driver): void {
    console.log('Sending notification to:', driver);
    alert(`Sending notification to ${driver.firstName} ${driver.lastName}...`);
    // TODO: Implement API call
  }

  // Edit driver
  editDriver(driver: any): void {
    console.log('Editing driver:', driver);
    this.driverService.forceRefreshListing = true;
    this.router.navigate(['admin/driver/edit', driver.id]);
  }

  // Delete driver
  // deleteDriver(driver: Driver): void {
  //   const confirmed = confirm(`Are you sure you want to delete ${ driver.firstName } ${ driver.lastName }?`);

  //   if (confirmed) {
  //     console.log('Deleting driver:', driver);
  //     // TODO: Implement API call

  //     // Remove from array (temporary)
  //     const index = this.allDrivers.findIndex(d => d.id === driver.id);
  //     if (index > -1) {
  //       this.allDrivers.splice(index, 1);
  //       this.filteredDrivers = [...this.allDrivers];
  //     }

  //     alert(`Driver ${ driver.firstName } ${ driver.lastName } deleted successfully!`);
  //   }
  // }

  // Get full name
  getFullName(driver: any): string {
    // return `${ driver.firstName } ${ driver.lastName } `;
    return `${driver.first_name} ${driver.last_name} `;
  }

  // Get pagination info
  getPaginationInfo(): string {
    const total = this.driverCount;

    if (total === 0 || !total) {
      return 'No drivers found';
    }

    this.totalPages = Math.ceil(total / this.itemsPerPage);

    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(this.currentPage * this.itemsPerPage, total);

    return `Showing ${start} - ${end} of ${total} Drivers`;
  }

  // Navigation
  goBack(): void {
    this.router.navigate(['/dashboard']);
  }
  clearText() {
    this.searchQuery = '';
    this.cross = false;
    this.onSearch();
  }
  goToDriverDetails(driverId: number | string) {
    this.router.navigate(['/admin/driver/detail', driverId]);
  }
  closeModal(): void {
    this.isModalOpen = false;
    this.showError = false;
    this.resetForm();
  }
  messageText: string = '';
  selectedFiles: File[] = [];
  filePreviews: { file: File; url: string }[] = [];
  charCount: number = 0;
  maxChars: number = 500;
  recipientType: 'customers' | 'drivers' | 'all' = 'drivers';
  isModalOpen: boolean = false;
  resetForm(): void {
    this.messageText = '';
    this.selectedFiles = [];
    this.filePreviews = [];
    this.charCount = 0;
  }
  toggleRecipientType(type: 'customers' | 'drivers'): void {
    this.recipientType = type;
  }
  showError: boolean = false;

  sendNotificationSpecifDriver(): void {
    if (!this.messageText.trim()) {
      // alert('Please enter a message');
      this.showError = true;
      return;
    }
    const recipient = this.recipientType === 'customers' ? 'Customer' : 'Driver';

    console.log('Sending notification to:', recipient);
    console.log('Message:', this.messageText);
    console.log('Files:', this.selectedFiles.length);

    const formData = new FormData();

    // message
    formData.append('message', this.messageText);

    // send_to mapping
    const sendTo = this.recipientType === 'customers' ? 'Customer' : 'Driver';
    formData.append('send_to_group', sendTo);

    // images from your onFileSelect
    if (this.selectedFiles.length > 0) {
      this.selectedFiles.forEach((file: File) => {
        formData.append('notification_image', file, file.name);
      });
    }
    formData.append('title', 'Driver Notification');
    formData.append('send_to_user', this.driverId);

    this.driverService.sendNotificationToGroup(formData).subscribe((res: any) => {
      this.toast.show('success', res.resultDescription);
      this.driverId = '';
    }, (err: any) => {
      this.toast.show('error', 'Failed to Send Notification');
    })
    this.closeModal();
  }
  sendNotification() {
    if (this.driverId) {
      this.sendNotificationSpecifDriver();
    }
    else {
      this.sendGenericNotification();
    }
  }
  sendGenericNotification(): void {
    if (!this.messageText.trim()) {
      this.showError = true;
      // alert('Please enter a message');
      return;
    }
    if (!this.messageText.trim()) {
      this.showError = true;
      return;
    }
    this.showError = false;

    const formData = new FormData();

    // message
    formData.append('message', this.messageText);

    // send_to mapping
    const sendTo = this.recipientType === 'customers' ? 'Customer' : 'Driver';
    formData.append('send_to_group', sendTo);

    // images from your onFileSelect
    if (this.selectedFiles.length > 0) {
      this.selectedFiles.forEach((file: File) => {
        formData.append('notification_image', file, file.name);
      });
    }
    formData.append('title', 'Generic Notification');
    this.notificationService.sendGenericNotification(formData)
      .subscribe((res: any) => {
        if (res?.resultCode == '0') {
          this.toast.show('error', res?.errorMessage);
        } else if (res.resultDescription) {
          this.toast.show('success', res?.resultDescription || 'Notification sent successfully');
          this.closeModal();
        }
      }, () => {
        this.toast.show('error', 'Failed to Send Notification');;
      });
    this.closeModal();
  }
  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.filePreviews.splice(index, 1);
  }
  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);

      files.forEach(file => {
        if (file.type.startsWith('image/')) {
          this.selectedFiles.push(file);

          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.filePreviews.push({
              file: file,
              url: e.target.result
            });
          };
          reader.readAsDataURL(file);
        }
      });
    }
  }
  getCharCountClass(): string {
    if (this.charCount >= 450) return 'limit-danger';
    if (this.charCount >= 400) return 'limit-warning';
    return '';
  }
  updateCharCount(): void {
    this.charCount = this.messageText.length;
  }
  driverId: any
  openModal(driverId?: any): void {
    this.isModalOpen = true;
    this.driverId = driverId
    this.resetForm();
  }
  openModalG(): void {
    this.isModalOpen = true;
    this.resetForm();
  }
  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.closeModal();
    }
  }
  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.driverList(); // call API with new page
    }
    localStorage.setItem('DriverPage', String(this.currentPage));
  }
  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.driverList();
    }
    localStorage.setItem('DriverPage', String(this.currentPage));
  }
  async deleteDriver(driverId: any): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Driver',
      'Are you sure you want to delete this driver? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      // console.log("FormData Value:", formdata.get('order_ids'));
      this.driverService.driverDelete(driverId).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          if (data.resultDescription) {
            this.toast.show('success', data.resultDescription);
            this.fetchAllDrivers();
          }
        },
        (error: any) => {
          this.authService.dataError(error);
        }
      );
    }
  }
}

